
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const CaretUpIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M42.3958 30.803C45.2004 27.0657 50.8015 27.0657 53.6061 30.803L74.5886 58.7634C78.0509 63.3771 74.7803 70 68.9835 70H27.0184C21.2215 70 17.951 63.377 21.4132 58.7634L42.3958 30.803ZM47.9999 35C45.6222 37.9686 26.9999 63 26.9999 63H68.9999C68.9999 63 50.2417 37.747 47.9999 35Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M45.1952 32.9038C46.5998 31.0321 49.4021 31.0321 50.8067 32.9038L71.7893 60.8642C73.5301 63.1839 71.8792 66.5 68.9835 66.5H27.0184C24.1228 66.5 22.4719 63.1839 24.2127 60.8642L45.1952 32.9038Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M42.3958 30.803C45.2004 27.0657 50.8015 27.0657 53.6061 30.803L74.5886 58.7634C78.0509 63.3771 74.7803 70 68.9835 70H27.0184C21.2215 70 17.951 63.377 21.4132 58.7634L42.3958 30.803ZM47.9999 35C45.6222 37.9686 26.9999 63 26.9999 63H68.9999C68.9999 63 50.2417 37.747 47.9999 35Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M45.1952 32.9038C46.5998 31.0321 49.4021 31.0321 50.8067 32.9038L71.7893 60.8642C73.5301 63.1839 71.8792 66.5 68.9835 66.5H27.0184C24.1228 66.5 22.4719 63.1839 24.2127 60.8642L45.1952 32.9038Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
